import React, { useEffect, useState } from "react";
import "./style/basketTableStyle.scss";
import { BasketItem } from "../../models/BasketItem";
import "../../../style/block.scss";
import "../../../style/feature.scss";
import "./style/basketItem.scss";
import { HiOutlineTicket, HiOutlineX } from "react-icons/hi";
import { BiIdCard, BiPurchaseTagAlt } from "react-icons/bi";
import { BsPiggyBank } from "react-icons/bs";
import { TicketAccess } from "../../models/TicketAccess";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors } from "../../store/alerts/alertsActions";
import { State } from "../../store";
import useFacility from "../../../utils/hooks/useFacility";
import useKortosfera from "../SaleMovie/CinemaHall/hooks/Socks/useKortosfera";
import { useTranslation } from "react-i18next";

interface IProps {
  item: BasketItem;
  index: number;
  onRemoveBasket: (index: number) => void;
  handleGetBasket: Function;
  handleAddBasket: (
    assortIds: string,
    price: number,
    ticketAccess: TicketAccess | any,
    validFrom: string | null,
    qnt: number | 1
  ) => void;
}

const BasketListItem: React.FC<IProps> = ({
  item,
  index,
  onRemoveBasket,
  handleAddBasket,
  handleGetBasket,
}: IProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearErrors());
  }, []);
  const facilityIds = useFacility();
  const alertLogin = useSelector((state: State) => state.alerts.errors);

  const [additionalAsortName, setAdditionalAsortName] = useState<string>("");

  const [plusAssort, setPlusAssort] = useState<boolean>(true);
  const [minusAssort, setMinusAssort] = useState<boolean>(true);

  // tutaj juz mam asortname wiec tu zrobimy walidacje

  useEffect(() => {
    if (facilityIds === "1220") {
      if (item.assortName === "OPIEKUN OS. Z NIEPEŁNOSPRAWNOŚCIĄ int.") {
        setPlusAssort(false);
        setMinusAssort(true);
      }
      // setAdditionalAsortName("PRZEWODNIK");
    }
    if (facilityIds === "1220") {
      if (item.assortName === "BILET OPIEKUN GRUPY INT.") {
        setPlusAssort(false);
        setMinusAssort(false);
      }
      // setAdditionalAsortName("PRZEWODNIK");
    }
    if (facilityIds === "1224") {
      if (item.assortName === "PRZEWODNIK") {
        setPlusAssort(false);
        setMinusAssort(false);
      }
      // setAdditionalAsortName("PRZEWODNIK");
    }
    // if (facilityIds === "1214" || facilityIds === "1213" || facilityIds === "1230") {
    //   if (item.assortName === "Opłata internetowa") {
    //     setPlusAssort(false);
    //     setMinusAssort(false);
    //   }
    // }

    if (item.assortName === "Opłata internetowa") {
      setPlusAssort(false);
      setMinusAssort(false);
    }
  }, [facilityIds]);

  useEffect(() => {
    if (facilityIds === "1228") {
      if (
        item.assortName === "Opiekun Wystawa" ||
        item.assortName === "Opiekun Pracownie" ||
        item.assortName === "Opiekun Edukator"
      ) {
        setPlusAssort(false);
        setMinusAssort(false);
      }
      if (
        item.assortName === "Asystent Wystawa" ||
        item.assortName === "Asystent Laboratorium" ||
        item.assortName === "Asystent Edukator"
      ) {
        setPlusAssort(false);
      }
    }
  }, [item]);

  return (
    <React.Fragment>
      <div className="basket-list-item flex-between-center">
        <div className="basket-list-item-icon">
          {item.ticket === true && <HiOutlineTicket className="icon" />}
          {item.pass === true && <BiIdCard className="icon" />}
          {item.service === true && <BiPurchaseTagAlt className="icon" />}
          {item.accountIncome === true && <BsPiggyBank className="icon" />}
          {item.assortName === "Opłata internetowa" && <BsPiggyBank className="icon" />}
        </div>

        <div className="basket-list-item-text">
          <b>{item.assortName}</b>
          {item.ticketAccess[0] ? (
            <React.Fragment>
              <span>
                {t("data")}: {item.ticketAccess[0].startDate}
              </span>
            </React.Fragment>
          ) : (
            <div className="flex-start-center basket-list-valid-from">
              {!item.service && (
                <span>
                  {t("data_rozpoczecia")}: {item.validFrom}
                </span>
              )}
            </div>
          )}
        </div>

        <b className="basket-list-item-price">
          {item.price} {t("zl")}
        </b>

        <div className="qnt flex-center-center">
          <React.Fragment>
            {!minusAssort ? (
              <button className="flex-center-center qnt-button qnt-opacity">-</button>
            ) : (
              <button
                className="flex-center-center qnt-button qnt-opacity"
                onClick={() => {
                  handleAddBasket(item.assortIds, item.price, item.ticketAccess, null, -1);
                  dispatch(clearErrors());
                  handleGetBasket();
                }}
              >
                -
              </button>
            )}
          </React.Fragment>

          <input disabled className="qnt-input" type="number" value={item.qnt} />

          <React.Fragment>
            {!plusAssort ? (
              <button className="flex-center-center qnt-button qnt-opacity">+</button>
            ) : (
              <button
                className="flex-center-center qnt-button"
                onClick={() => {
                  handleAddBasket(item.assortIds, item.price, item.ticketAccess, null, 1);
                  handleGetBasket();
                }}
              >
                +
              </button>
            )}
          </React.Fragment>
        </div>

        <b className="basket-list-item-price">
          {item.price * item.qnt} {t("zl")}
        </b>

        <React.Fragment>
          {!plusAssort ? (
            <div className="basket-list-item-delete flex-center-center  qnt-opacity">
              <HiOutlineX className="icon" />
            </div>
          ) : (
            <div onClick={() => onRemoveBasket(index)} className="basket-list-item-delete flex-center-center move-up">
              <HiOutlineX className="icon" />
            </div>
          )}
        </React.Fragment>
      </div>
      {/* {alertLogin && alertLogin.length > 0 && <div className="alert alert-red">{alertLogin}</div>} */}
    </React.Fragment>
  );
};

export default BasketListItem;
